import styles from "../Profile/Profile.module.css";
import Backbutton from "../../assests/popup/backButton.svg";
import user from "../../assests/user.svg";
import { useRef, useState } from "react";

import {
  ref,
  uploadBytes,
  getDownloadURL,
  listAll,
  list,
} from "firebase/storage";
import { profileStorage } from "../../store/firebase-config";
import { useUserAuth } from "../../context/UserAuthContext";
import LoadingFromCenter from "../LoadingFromCenter/LoadingFromCenter";
import WhatsappLike from "../WhatsappLike/WhatsappLike";
import UpdateWhatsapp from "../UpdateWhatsapp/UpdateWhatsapp";
import EmailVerification from "../EmailVerification/EmailVerification";

function EditArea({ setEditProfile, data, setData }) {
  const inputRef = useRef();
  const [source, setSource] = useState("");
  const [profileImageData, setProfileImageData] = useState("");
  const [imageUrls, setImageUrls] = useState("");
  const {
    updateUserssProfile,
    currentUser,
    changesPresent,
    setChangesPresent,
    emailVerified,
    setEmailPopup,
    emailPopup,
  } = useUserAuth();
  const [updateNumber, setUpdateNumber] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [editedDetails, setEditedDetails] = useState({});
  const handleFileChange = async (event) => {
    const data = new FormData();
    const file = event.target.files[0];
    const url = URL.createObjectURL(file);
    setSource(url);
    // data.append('videoFile', file)
    // setting file to a state
    setProfileImageData(file);
    setChangesPresent(true);
  };

  // const imagesListRef = ref(storage, "images/");

  const handleChoose = async () => {
    inputRef.current.click();
  };

  const handleSave = async () => {
    // setSaveLoading(true);
    if (source) {
      if (user == source) {
        await updateUserssProfile(data, editedDetails, "", setEditProfile);
      } else {
        if (profileImageData == null) return;
        const imageRef = ref(profileStorage, `${currentUser.uid}`);
        const uploadBlob = await uploadBytes(imageRef, profileImageData);
        const getUrl = await getDownloadURL(uploadBlob.ref);
        // pohot url in the state imageUrls
        setImageUrls(getUrl);
        await updateUserssProfile(data, editedDetails, getUrl, setEditProfile);
      }
      // setSaveLoading(false);
    } else {
      await updateUserssProfile(
        data,
        editedDetails,
        currentUser.photoURL,
        setEditProfile
      );
      // setSaveLoading(false);
    }
  };
  const handleInputChange = (e) => {
    setChangesPresent(true);
    setData({ ...data, [e.target.id]: e.target.value });
    setEditedDetails((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };
  const handleRemove = () => {
    setSource(user);
  };
  const handleUpdateWPNumber = () => {
    setUpdateNumber(true);
  };
  return (
    <div>
      {updateNumber && (
        <UpdateWhatsapp setPopup={setUpdateNumber} type="update" />
      )}
      {emailPopup && <EmailVerification setPopup={setEmailPopup} />}

      <div className=" flex w-[100%] items-center justify-between p-[20px] z-10 sticky top-0 left-0 header-bg">
        <div className=" flex gap-[12px] items-center">
          <img
            onClick={() => {
              setEditProfile(false);
            }}
            className="h-[40px] w-[40px]  hover:cursor-pointer"
            src={Backbutton}
            alt=""
          />
          <p className="text-regular">Edit Profile</p>
        </div>
        {changesPresent && (
          <button
            className="text-[#0F6ABE] text-regular-medium"
            onClick={handleSave}
            disabled={saveLoading}
          >
            Save
          </button>
        )}
      </div>
      <div className={styles.prodiv}>
        <div className="pt-[10px] pb-[20px] ">
          <div className="flex gap-[26px] items-center">
            <img
              className={styles.propic}
              src={
                source
                  ? source
                  : currentUser.photoURL
                  ? currentUser.photoURL
                  : user
              }
              alt=""
            />
            <p className="text-[#606060] text-small max-w-[200px] text-left">
              Please provide your name and add a profile picture
            </p>
          </div>
          <input
            ref={inputRef}
            className="hidden"
            type="file"
            onChange={handleFileChange}
            accept=".jpeg,.png,.jpg"
          />
          <p
            className="text-regular text-[#0F6ABE] cursor-pointer mt-[13px] text-left px-[20px]"
            onClick={handleChoose}
          >
            Edit
          </p>
          {/* <p
            className="text-regular text-[#0F6ABE] cursor-pointer mt-[13px]"
            onClick={handleRemove}
            >
            Remove
          </p> */}
        </div>
        <div className="seperator" />
        <div className={styles.flec}>
          <p className="text-small">Name</p>
          <input
            className={styles.inputff}
            type="text"
            id="name"
            onChange={handleInputChange}
            value={data?.name}
          />
        </div>
        <div className={styles.flec}>
          <div className="flex items-center justify-between">
            <p className="text-small">Email</p>
            <p className="text-smallest2 text-[#787878]"> Non-editable field</p>
          </div>
          <div className="relative w-full">
            <input
              className={styles.inputff}
              type="email"
              id="email"
              onChange={handleInputChange}
              value={data?.email}
              readOnly
            />
            {emailVerified ? (
              <p className=" h-full absolute top-0 right-[10px] flex items-center text-[#0F6ABE] text-small cursor-pointer">
                Verified
              </p>
            ) : (
              <p
                className=" h-full absolute top-0 right-[10px] flex items-center text-[#0F6ABE] text-small cursor-pointer"
                onClick={() => setEmailPopup(true)}
              >
                Verify
              </p>
            )}
          </div>
        </div>
        <div className={styles.flec}>
          <div className="flex items-center justify-between">
            <p className="text-small">Whatsapp Number</p>
            <p className="text-smallest2 text-[#787878]"> Non-editable field</p>
          </div>
          <div className="relative w-full">
            <input
              className={styles.inputff}
              type="text"
              id="phoneNumber"
              value={data?.phoneNumber}
              onChange={handleInputChange}
              readOnly
            />
            <p
              className=" h-full absolute top-0 right-[10px] flex items-center text-[#0F6ABE] text-small cursor-pointer"
              onClick={handleUpdateWPNumber}
            >
              Update
            </p>
          </div>
        </div>

        {/* <div className={styles.saveParent}>
          <p
            className="text-[#FA6B6B] text-regular cursor-pointer"
            onClick={() => setEditProfile(false)}
          >
            Cancel
          </p>
          <button
            className="commonButton bg-[#EB0256]"
            onClick={handleSave}
            disabled={saveLoading}
            style={{
              color: "#ffffff",
              background: changesPresent ? "#EB0256" : "#606060",
            }}
          >
            Save
          </button>
        </div> */}
        {saveLoading && <LoadingFromCenter />}
      </div>
    </div>
  );
}

export default EditArea;
